import { render, staticRenderFns } from "./TableActionsMenu.vue?vue&type=template&id=e4266d5e&scoped=true&v-slot%3A%5B%60item.actions%60%5D=%7B%20item%20%7D&"
import script from "./TableActionsMenu.vue?vue&type=script&lang=js&"
export * from "./TableActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4266d5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VMenu})
